import React from "react";
import { ReferenceLine } from "recharts";

// 固定中の共有 x 値にガイド線（縦の参照線）を描く。赤破線で表示する。
// recharts はインラインで返した ReferenceLine 要素を直接の子として認識するため、
// 各 viewer のチャート内で {lockReferenceLine(lockedValue)} として呼び出して使う。
// recharts は子要素を JSX 宣言順で描画する（SVG なので後の要素が前面）。
// ガイド線をデータ系列より前面に出すため、必ず Line/Area の系列より後ろに置く。
// lockedValue が null（非固定）なら何も描かない。
export function lockReferenceLine(lockedValue: number | null): React.ReactElement | null {
    if (lockedValue == null) return null;
    return (
        <ReferenceLine
            x={lockedValue}
            xAxisId="0"
            stroke="#d32f2f"
            strokeDasharray="4 3"
            strokeWidth={1.5}
        />
    );
}
